import { IngredientProps } from '@/interfaces/models/ingredient';
import Ingredient from '@/models/ingredient';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((ingredientsProps: IngredientProps[]): Ingredient[] => {
      return ingredientsProps.map(Ingredient.createFromRequest);
    });
  }
};
